import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { companyList } from '../../services/Api';

export const fetchCompanies = createAsyncThunk(
    'company/fetchCompanies',
    async (_, { getState }) => {
        try {
            const { filters } = getState().company;
            const params = {
                sort: 'id',
                sort_order: 'desc',
                // page: filters.page,
                // limit: filters.limit,
                ...(filters.search && { company_name: filters.search }),
                ...(filters.from && { from: filters.from }),
                ...(filters.to && { to: filters.to }),
                ...(filters.status && { status: filters.status }),
            };

            const response = await companyList(params);
            return response;
        } catch (error) {
            throw error;
        }
    }
);

const initialState = {
    companies: [],
    loading: false,
    error: null,
    shouldRefresh: false,
    pagination: {
        currentPage: 1,
        totalPage: 1,
        showing: 10,
        total: 0
    },
    filters: {
        from: '',
        to: '',
        search: '',
        status: '',
        sorting: 'desc',
        // page: "1",
        // limit: "10",
    }
};

const companySlice = createSlice({
    name: 'company',
    initialState,
    reducers: {
        setShouldRefresh: (state, action) => {
            state.shouldRefresh = action.payload;
        },
        setFilters: (state, action) => {
            state.filters = { ...state.filters, ...action.payload, sort_by: 'created_at', sort_order: 'desc' };
        },
        resetFilters: (state) => {
            state.filters = initialState.filters;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCompanies.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCompanies.fulfilled, (state, action) => {
                state.loading = false;
                state.companies = action.payload?.data || [];
                if (action.payload.meta) {
                    state.pagination = {
                        currentPage: action.payload.meta.current_page || 1,
                        totalPage: action.payload.meta.last_page || 1,
                        showing: action.payload.meta.per_page || 10,
                        total: action.payload.meta.total || 0
                    };
                }
            })
            .addCase(fetchCompanies.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
                state.companies = [];
            });
    }
});

export const { setFilters, resetFilters, setShouldRefresh } = companySlice.actions;
export default companySlice.reducer;